export default {
  pageTitle: 'Events',
  pageDesc: 'Manage events for the current company. Switch to company workspace first.',
  personalWorkspaceAlert: 'You are in personal workspace. Switch to a company workspace to manage events.',
  searchPlaceholder: 'Search name, location, or description',
  addEvent: 'New event',
  editEvent: 'Edit event',
  emptyTable: 'No events yet',
  eventName: 'Event name',
  requiresRegistration: 'Registration',
  registrationApproval: 'Approval',
  approvalRequired: 'Required',
  approvalAuto: 'Auto-approve',
  eventCity: 'City / region',
  eventAddress: 'Address',
  eventIntro: 'Description',
  creator: 'Created by',
  createdAt: 'Created at',
  namePlaceholder: 'Enter event name',
  registrationNeedsApproval: 'Registration approval',
  cityPlaceholder: 'e.g. Guangzhou, Guangdong',
  citySelectPlaceholder: 'Select province / city',
  addressPlaceholder: 'Enter venue address',
  introPlaceholder: 'Enter event description',
  nameRequired: 'Event name is required',
  switchCompanyFirst: 'Please switch to company workspace first',
  createSuccess: 'Event created',
  updateSuccess: 'Event updated',
  loadFailed: 'Failed to load event details. Please try again.',
  deleteConfirmTitle: 'Delete event',
  deleteConfirmMessage: 'Delete event "{name}"?',
  deleteConfirmOk: 'Delete',
  deleteSuccess: 'Deleted',
  eventCreateGate: {
    needEventFirst: 'Save event info first to create the activity, then continue on other pages.'
  },
  wizardNav: {
    primaryAria: 'Event wizard primary navigation',
    primaryEvent: 'Event',
    primaryRegistration: 'Reg.',
    backToList: 'Back to events',
    close: 'Close',
    groupBasic: 'Basics',
    groupRegistration: 'Registration',
    groupMore: 'More',
    eventInfo: 'Event info',
    location: 'Location',
    registration: 'Registration',
    registrationForm: 'Registration form',
    share: 'Sharing',
    microsite: 'Microsite',
    schedule: 'Schedule'
  },
  eventInfo: {
    pageTitle: 'Event info',
    lastSaved: 'Last saved',
    helpTitle: 'Tips',
    helpDesc: 'Set basic info, location, and registration here. Use the province/city cascader for event location.'
  },
  eventLocation: {
    pageTitle: 'Location',
    helpTitle: 'Tips',
    helpDesc: 'Set city and venue address shown on registration and event pages.'
  },
  eventRegistration: {
    pageTitle: 'Registration',
    helpTitle: 'Tips',
    helpDesc: 'Enable registration for sign-ups; turn on approval if entries must be reviewed.'
  },
  schedule: {
    pageTitle: 'Schedule',
    helpTitle: 'Tips',
    helpDesc: 'Manage sessions under this event. Filter by date and search by name or location.',
    add: 'Add',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    searchPlaceholder: 'Name / location',
    filterDatePlaceholder: 'Select date',
    colName: 'Session name',
    colTime: 'Start – end',
    colLocation: 'Location',
    colIntro: 'Description',
    formStart: 'Start',
    formEnd: 'End',
    formRegion: 'Region',
    formAddress: 'Address',
    regionPlaceholder: 'Province / city / district',
    addressPlaceholder: 'Enter detailed address',
    introTip: 'Optional. Shown on the decorated session detail page if you use microsite decoration.',
    submitAdd: 'Add session',
    submitEdit: 'Save session',
    backToList: 'Back to list',
    formHelpDesc: 'Fill in session name, time, location and description. Fields marked * are required.',
    namePlaceholder: 'Enter session name',
    introPlaceholder: 'Enter description',
    nameRequired: 'Session name is required',
    startRequired: 'Start time is required',
    endRequired: 'End time is required',
    endAfterStart: 'End time must be after start time',
    regionRequired: 'Region is required',
    addressRequired: 'Address is required',
    createSuccess: 'Session added',
    updateSuccess: 'Session updated',
    saveFailed: 'Save failed',
    copySuccess: 'Copied',
    copyFailed: 'Copy failed',
    deleteConfirmTitle: 'Delete sessions',
    deleteConfirmMessage: 'Delete {count} selected session(s)?',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    loadFailed: 'Failed to load schedule'
  },
  eventTime: 'Event time',
  timeStartPlaceholder: 'Start',
  timeEndPlaceholder: 'End',
  list: {
    createActivity: 'Create event',
    topForm: 'Forms',
    topItinerary: 'Itinerary',
    topPayment: 'Payments',
    topAudit: 'Review list',
    topAssociation: 'Registration link',
    allActivities: 'All events ({count})',
    advancedFilter: 'Advanced filter',
    searchNameOnly: 'Search by name',
    countdown: 'Countdown',
    share: 'Share',
    sort: 'Sort',
    qrShare: 'QR code',
    addressUnset: 'No location set',
    statusUnset: '—',
    statusEnded: 'Ended',
    statusOngoing: 'In progress',
    countdownDays: '{days}d',
    opActivity: 'Event',
    opSchedule: 'Schedule',
    opShare: 'Share',
    opDecorate: 'Design',
    opPayment: 'Pay',
    opRegistration: 'Reg.',
    opCheckin: 'Check-in',
    opSeating: 'Seats',
    opDelete: 'Delete'
  }
}
